if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.submitButton = this.querySelector('[type="submit"]');
        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();
        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        var spinner = this.querySelector(".loading__spinner");
        if (spinner) spinner.classList.remove("hidden");

        var btnSpan = this.submitButton.querySelector("span");
        var originalText = btnSpan ? btnSpan.textContent : "";
        if (btnSpan) btnSpan.textContent = "Adding to cart...";

        const formData = new FormData(this.form);

        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Accept": "application/json", "X-Requested-With": "XMLHttpRequest" },
          body: formData,
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status && response.status !== 200) {
              this.handleErrorMessage(response.description);
              this.error = true;
              return;
            }

            // Use existing cart drawer system
            if (typeof updateCartDrawer === "function") {
              updateCartDrawer().then(() => {
                if (typeof openCartDrawer === "function") {
                  openCartDrawer();
                }
              });
            } else {
              // Fallback: redirect to cart
              window.location = "/cart";
              return;
            }

            if (typeof updateCartItemCounts === "function" && response.items) {
              // Cart item count will be updated by updateCartDrawer
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (spinner) spinner.classList.add("hidden");
            if (btnSpan) btnSpan.textContent = originalText;
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message",
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    },
  );
}
